import React, { Component } from 'react';
import SignatureForm from './SignatureForm';
import SignatureComponent from './SignatureComponent';
import AppLayout from './Layout';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.updateSignature = this.updateSignature.bind(this);
    }

    updateSignature(user) {
        console.log('setting state: ', user);
        this.setState(user);
    }

    render() {
        return (
            <div>
                <AppLayout
                    left={
                        <SignatureForm updateSignature={this.updateSignature} />
                    }
                    right={<SignatureComponent user={this.state} />}
                />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js